import { useState, useEffect } from 'react';
import { PriceAndQuantity } from './types';
import { CartService } from '../../../../services';

export type Invoice = {
  sum: number;
  tax: number;
  taxPercent: number;
  shipping: number;
  shippingTax: number;
  total: number;
  error?: string;
}

const taxRate = 0.19;
const shippingCost = 13.80;

const roundToTwoDecimals = (num: number): number => Math.round(num * 100) / 100;

export const useInvoice = (products: PriceAndQuantity[]): Invoice => {
  const [update, setUpdate] = useState(false);
  const refreshLimit = () => setUpdate(!update);

  useEffect(() => {
    window.addEventListener(CartService.cartUpdateEvent, refreshLimit);
    return () => window.removeEventListener(CartService.cartUpdateEvent, refreshLimit);
  }, [update]);

  try {
    const sum = roundToTwoDecimals(
      products
        .map(({ price, quantity }) => parseFloat(price) * quantity)
        .reduce((a, b) => a + b, 0),
    );
    const tax = roundToTwoDecimals(sum * taxRate);
    const shipping = roundToTwoDecimals(shippingCost);
    const shippingTax = roundToTwoDecimals(shippingCost * taxRate);
    const total = roundToTwoDecimals(sum + tax + shipping + shippingTax);

    return {
      sum,
      tax,
      taxPercent: taxRate * 100,
      shipping,
      shippingTax,
      total,
    };
  } catch {
    return {
      sum: 0,
      tax: 0,
      taxPercent: 0,
      shipping: 0,
      shippingTax: 0,
      total: 0,
      error: 'Error calculating invoice',
    };
  }
};
